import { FilterModalTypes } from '..';

import { filterHasSelection } from './filterHasSelection';

export const applyFilterFromOutside = (
  filterAtom: FilterModalTypes.FilterAtom,
  fieldName: string,
  selections: FilterModalTypes.SelectedFiltersProps['filter']
) => {
  const availableFilters = [...filterAtom.availableFilters];
  const appliedFilters = [...filterAtom.appliedFilters];
  const selectedFilters = [...filterAtom.selectedFilters];

  const filterBeingApplied = availableFilters.find((filter) => filter.fieldName === fieldName);
  const filterSelectedIndex = selectedFilters.findIndex((filter) => filter.fieldName === fieldName);
  const filterAppliedIndex = appliedFilters.findIndex((filter) => filter.fieldName === fieldName);

  if (filterSelectedIndex === -1 || !filterBeingApplied) {
    return filterAtom;
  }

  const hasSelection = filterHasSelection(
    filterBeingApplied?.type,
    selections,
    filterAtom.availableFilters[filterSelectedIndex]
  );

  if (filterAppliedIndex === -1 && hasSelection) {
    appliedFilters.push({ fieldName, filter: selections });
  } else if (filterAppliedIndex >= 0 && !hasSelection) {
    appliedFilters.splice(filterAppliedIndex, 1);
  } else {
    appliedFilters[filterAppliedIndex] = { fieldName, filter: selections };
  }

  selectedFilters[filterSelectedIndex] = { fieldName, filter: selections };

  return { ...filterAtom, appliedFilters, selectedFilters };
};
